import { render, staticRenderFns } from "./home.vue?vue&type=template&id=844ae5fe&scoped=true&"
var script = {}
import style0 from "./home.vue?vue&type=style&index=0&id=844ae5fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844ae5fe",
  null
  
)

export default component.exports